var _Path, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
var SvgHomePlateBorder = function SvgHomePlateBorder(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 129.6 123.12"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "url(#home-plate-border_svg__a)",
    strokeWidth: 2.115,
    d: "M64.8 1.058c15.487 0 29.368 6.903 38.759 17.818l.316.368h4.822c10.956 0 19.845 8.919 19.845 19.929v62.96c0 11.01-8.889 19.929-19.845 19.929H20.903c-10.956 0-19.845-8.919-19.845-19.929v-62.96c0-11.01 8.889-19.929 19.845-19.929h4.822l.316-.368C35.431 7.961 49.313 1.058 64.8 1.058Z"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "home-plate-border_svg__a",
    x1: 64.8,
    x2: 64.8,
    y1: 123.12,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF908"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FFFF9E"
  })))));
};
export default SvgHomePlateBorder;